import { render, staticRenderFns } from "./outboundreportmanagement.vue?vue&type=template&id=65ecb1be&scoped=true&"
import script from "./outboundreportmanagement.vue?vue&type=script&lang=js&"
export * from "./outboundreportmanagement.vue?vue&type=script&lang=js&"
import style0 from "./outboundreportmanagement.vue?vue&type=style&index=0&id=65ecb1be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ecb1be",
  null
  
)

export default component.exports